import React from 'react';
import FeatureFlagPlaceholder from 'components/ui/FeatureFlagPlaceholder';

export default function GovernanceAnalytics() {
  return (
    <FeatureFlagPlaceholder
      title="Governance Analytics"
      description="Participation rates, voting history, quorum trends, and delegate activity dashboards will be available in Phase 2."
      phase="Phase 2"
    />
  );
}
